import Vue from 'vue';
import DateUtil from '../../utils/DateUtil';
import { isAndroid, getUniqueID } from '../../utils/util';
import ProjectConfigDetailData from '@/utils/global_val';
import cookie from '../../utils/cookie'

/*
    入参说明
    options: {
        orderSn,
        totalAmount, // 单位分
        currencyCode,
        orderDesc,
        orderSubject
    }
*/

const _this = Vue.prototype;

export function pay(options) {
    let uniqueID = getUniqueID();
    let returnUrl = `${location.protocol}//${location.host}/pay/jump/${uniqueID}`, // 支付回调URL
        clientDesc = `datamall_h5_${isAndroid() ? 'android': 'ios'}`,
        channelCode = ProjectConfigDetailData.payChannelCode;

    // 通过中台接口获取收银台链接，然后去收银台支付
    _this.$http.post({
        url: '/webmps/payment/cashier/createorder',
        data: {                        
            orderSn: options.orderSn,
            returnUrl,
            timeStamp: DateUtil.formatDateTime(new Date(), 'yyyyMMddHHmmssSSS'),
            clientDesc,
            totalAmount: options.totalAmount,
            currencyCode: options.currencyCode,
            channelCode,            
            payFunction: options.payFunction,
            orderDesc: options.orderDesc,
            orderSubject: options.orderSubject,
            // 新增参数，可以根据国家配置收银台模板
            countryCode:options.countryCode,
        }
    }).then(res => {
        if(res.cashierUrl) {
            let localeCode = cookie.getCookie('langType'),
            

            //默认就用安卓模板
            clientMode = 'ANDROID';
            // if(localeCode === 'in-ID') localeCode = 'id-ID';
            
            // 保存orderSN用于记录日志消费            
            window.localStorage.setItem('localOrderInfo', JSON.stringify({
                orderSn: options.orderSn,
                uniqueID,
            }));
            sessionStorage.setItem('currentGoodsCode', options.goodsCode || '');
            let payUrl = `${res.cashierUrl}&clientMode=${clientMode}&localeCode=${localeCode.split('-').join('_')}`;
            location.href = payUrl;
        }
    }).catch(err => {
        _this.$toast(err)
    });
}